import { defineStore } from 'pinia'
import _, { camelCase } from 'lodash'
import type { IDelivererVm } from '@/types'
import type { SortType } from 'vue3-easy-data-table'

export const useDelivererStore = defineStore({
  id: 'useDelivererStore',
  state: () => ({
    rootUrl: '/api/Participation/',
    deliverers: [] as Array<IDelivererVm>,
    totalCount: 0,
    isLoadingDeliverer: false,
    isLoadingValidate: false,
    delivererTableHeaders: [
      { text: 'First Name', value: 'firstName', sortable: true },
      { text: 'Last Name', value: 'lastName', sortable: true },
      { text: 'Deliverer Type', value: 'delivererType', sortable: true },
      { text: 'Email / User ID', value: 'email', sortable: true },
      { text: 'Date Created', value: 'dateCreated', sortable: true },
      { text: '', value: 'buttons', width: 110 }
    ]
  }),
  actions: {
    async getDeliverers(
      searchByName?: string,
      searchByEmail?: string,
      page?: number,
      rowsPerPage?: number,
      sortBy?: string | string[],
      sortType?: SortType | SortType[]
    ) {
      if (this.isLoadingDeliverer) {
        return
      }

      this.isLoadingDeliverer = true
      try {
        var url = `${this.$state.rootUrl}GetDeliverers?page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortType=${sortType}`
        if (searchByName) url += `&name=${searchByName}`
        if (searchByEmail) url += `&email=${searchByEmail}`

        const response = await this.axiosFactory.withoutToken().get(url)
        this.totalCount = response.data.data.totalCount
        this.deliverers = response.data.data.data
      } catch (error: any) {
        console.log(error.response)
      } finally {
        this.isLoadingDeliverer = false
      }
    },
    async removeDeliverer(memberUID: string): Promise<any> {
      const response = await this.axiosFactory
        .withoutToken()
        .post(`${this.$state.rootUrl}RemoveDeliverer?memberUID=${memberUID}`)

      if (!response.data?.success) {
        console.log('API Error Message: ', response.data?.errorMessage)
      }

      return response.data?.data
    },
    async createUpdateDeliverer(deliverer: IDelivererVm): Promise<any> {
      const response = await this.axiosFactory
        .withoutToken()
        .post(`${this.$state.rootUrl}CreateUpdateDeliverer`, deliverer)

      if (!response.data?.success) {
        console.log('API Error Message: ', response.data?.errorMessage)
      }

      return response.data?.data
    },
    async loadDelivererTableHeaders() {
      var url = `${this.$state.rootUrl}GetDelivererTableHeaders`
      const response = await this.axiosFactory.withoutToken().get(url)
      console.log('response', response)
      this.delivererTableHeaders = response.data.data.map((x: any) => {
        return {
          ...x,
          value: camelCase(x.value)
        }
      })
    },
    async validateDeliverer(
      name?: string,
      email?: string,
      delivererTypeId?: number,
      isAllAbilities?: boolean
    ): Promise<any> {
      try {
        this.isLoadingValidate = true
        const response = await this.axiosFactory
          .withoutToken()
          .get(
            `${this.$state.rootUrl}ValidateDeliverer?name=${name}&email=${email}&delivererTypeId=${delivererTypeId}&isAllAbilities=${isAllAbilities}`
          )

        if (!response.data?.success) {
          console.log('API Error Message: ', response.data?.errorMessage)
        }

        return response.data?.data.memberUID
      } catch (error: any) {
        console.log(error.response)
      } finally {
        this.isLoadingValidate = false
      }
    },
    async validateDelivererByMembershipId(
      name?: string,
      membershipId?: string,
      delivererTypeId?: number,
      isAllAbilities?: boolean
    ): Promise<any> {
      const response = await this.axiosFactory
        .withoutToken()
        .get(
          `${this.$state.rootUrl}ValidateDelivererByMembershipId?name=${name}&membershipId=${membershipId}&delivererTypeId=${delivererTypeId}&isAllAbilities=${isAllAbilities}`
        )

      if (!response.data?.success) {
        console.log('API Error Message: ', response.data?.errorMessage)
      }

      return response.data?.data?.memberUID
    }
  }
})
